import platform from 'platform'

export const isChrome = (): boolean => platform.name === 'Chrome'
export const isSafari = (): boolean => platform.name === 'Safari'
export const isFirefox = (): boolean => platform.name === 'Firefox'
